import { render, staticRenderFns } from "./contactAlert.vue?vue&type=template&id=3000b989&scoped=true"
import script from "./contactAlert.vue?vue&type=script&lang=js"
export * from "./contactAlert.vue?vue&type=script&lang=js"
import style0 from "./contactAlert.vue?vue&type=style&index=0&id=3000b989&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3000b989",
  null
  
)

export default component.exports